/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import Tick from "./Tick";
import DiagCodeSelect from "./DiagCodeSelect";

export default class DiagCodeSelectModal extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {}
        };
    }

    change = (dc) => {
        this.props.onChange(dc);
        this.setState({ info: {} });
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title><L>Diagnosis Codes</L></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DiagCodeSelect item={this.state.item} onChange={this.change} />
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={this.props.onHide}><L>Close</L></button>
            </Modal.Footer>
        </Modal>
    }
}